import { useQueryClient } from "@tanstack/react-query";
import { $api } from "../generated/client";
import type { SetSuperpowerBodyDto } from "../generated/schema";
import { useApiMutation } from "./use-api-mutation";

/** Super admin accounts, their MFA state and the latest grants (BAB-3035). */
export function useSuperpowers() {
  return $api.useQuery("get", "/super-admin/superpowers");
}

/** Grant or revoke, proven by a fresh MFA code of the caller. */
export function useSetSuperpower() {
  const queryClient = useQueryClient();

  return useApiMutation("put", "/super-admin/superpowers", {
    notify: { error: false },
    invalidate: () => {
      queryClient.invalidateQueries({
        queryKey: ["get", "/super-admin/superpowers"],
      });
    },
    mapVariables: (body: SetSuperpowerBodyDto) => ({ body }),
  });
}
